/**
 * Module definition and dependencies
 */
angular.module('paniersService.Service', [
  'ngResource',
])

/**
 * Service
 */
  .factory('Paniers', ['$resource', 'Config', function ($resource, Config) {
    var api = $resource(Config.API_BASE_URL + '/paniers/:id/', {}, {
      update: {
        method: 'PUT',
      },
      query: {
        isArray: false,
      },
    });
    api.prototype.createOrUpdate = function () {
      if (this.id) {
        return this.$update();
      } else {
        return this.$save();
      }
    }
    return api;
  }]);
